module.exports = __webpack_public_path__ + "static/media/sheep.14e10a91.png";